import {
    POSITION_LEFT,
    POSITION_RIGHT,
    TEXT_ANCHOR_END,
    TEXT_ANCHOR_START,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import isUpsideDown from '%paysera_seat_selection/js/seatSelection/services/isUpsideDown';
import calculateCollectionLabel from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/calculateCollectionLabel';
import getYOffsetForSeat from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getYOffsetForSeat';

function calculateRowLabel(
    rowLabeling,
    rowIndex,
    rowCount,
    row,
    fontConfig,
    spacing,
    seatConfig,
) {
    const text = calculateCollectionLabel(rowLabeling, rowIndex + 1, rowCount, rowCount);

    const compiledLeft = {
        ...row.labelLeft.compiled,
        size: fontConfig.size.row,
        family: fontConfig.family,
        color: fontConfig.color,
    };
    const compiledRight = {
        ...row.labelRight.compiled,
        size: fontConfig.size.row,
        family: fontConfig.family,
        color: fontConfig.color,
    };

    const rowUpsideDown = isUpsideDown(row.transformation.rotation + row.sector.transformation.rotation);
    compiledLeft.x = -fontConfig.size.row / 2;
    compiledLeft.y = getYOffsetForSeat(seatConfig);
    const transformation = { rotation: -row.transformation.rotation - row.sector.transformation.rotation };
    const labelLeft = {
        ...row.labelLeft,
        textAnchor: rowUpsideDown ? TEXT_ANCHOR_START : TEXT_ANCHOR_END,
        compiled: compiledLeft,
        transformation,
        text,
    };

    compiledRight.x = row.compiled.polygon.dimensions.width + spacing.v;
    compiledRight.y = getYOffsetForSeat(seatConfig);
    const labelRight = {
        ...row.labelRight,
        textAnchor: rowUpsideDown ? TEXT_ANCHOR_END : TEXT_ANCHOR_START,
        compiled: compiledRight,
        transformation,
        text,
    };

    compiledLeft.text = { ...compiledLeft.text, x: compiledLeft.x, y: compiledLeft.y };
    compiledRight.text = { ...compiledRight.text, x: compiledRight.x, y: compiledRight.y };

    if (rowLabeling.position === POSITION_LEFT) {
        labelRight.text = null;
    }
    if (rowLabeling.position === POSITION_RIGHT) {
        labelLeft.text = null;
    }

    return {
        labelLeft,
        labelRight,
    };
}

export default calculateRowLabel;
